if (!customElements.get('cart-drawer-upsell-item')) {
  customElements.define(
    'cart-drawer-upsell-item',
    class CartDrawerUpsellItem extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        event.preventDefault();
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        const cartDrawer = document.querySelector('cart-drawer');
        const variantId = this.button.dataset.variantId;
        const spinner = this.button.querySelector('.loading__spinner');

        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        spinner?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        if (cartDrawer) {
          formData.append(
            'sections',
            cartDrawer.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'cart-drawer-upsell',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            }

            if (cartDrawer) {
              cartDrawer.renderContents(response);
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-drawer-upsell',
              productVariantId: variantId,
              cartData: response,
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.button.classList.remove('loading');
            this.button.removeAttribute('aria-disabled');
            spinner?.classList.add('hidden');
          });
      }
    }
  );
}
